/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dev_Item_Disable_PosthogInputs */

const en_dev_item_disable_posthog = /** @type {(inputs: Dev_Item_Disable_PosthogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disable PostHog`)
};

const ar_dev_item_disable_posthog = /** @type {(inputs: Dev_Item_Disable_PosthogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعطيل PostHog`)
};

const bn_dev_item_disable_posthog = /** @type {(inputs: Dev_Item_Disable_PosthogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostHog বন্ধ করুন`)
};

const de_dev_item_disable_posthog = /** @type {(inputs: Dev_Item_Disable_PosthogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostHog deaktivieren`)
};

const es_dev_item_disable_posthog = /** @type {(inputs: Dev_Item_Disable_PosthogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deshabilitar PostHog`)
};

const fr_dev_item_disable_posthog = /** @type {(inputs: Dev_Item_Disable_PosthogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactiver PostHog`)
};

const pt_dev_item_disable_posthog = /** @type {(inputs: Dev_Item_Disable_PosthogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desativar PostHog`)
};

const zh_dev_item_disable_posthog = /** @type {(inputs: Dev_Item_Disable_PosthogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`禁用 PostHog`)
};

const tr_dev_item_disable_posthog = /** @type {(inputs: Dev_Item_Disable_PosthogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostHog'u devre dışı bırak`)
};

const ru_dev_item_disable_posthog = /** @type {(inputs: Dev_Item_Disable_PosthogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отключить PostHog`)
};

const pl_dev_item_disable_posthog = /** @type {(inputs: Dev_Item_Disable_PosthogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyłącz PostHog`)
};

/**
* | output |
* | --- |
* | "Disable PostHog" |
*
* @param {Dev_Item_Disable_PosthogInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const dev_item_disable_posthog = /** @type {((inputs?: Dev_Item_Disable_PosthogInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dev_Item_Disable_PosthogInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_dev_item_disable_posthog(inputs)
	if (locale === "bn") return bn_dev_item_disable_posthog(inputs)
	if (locale === "de") return de_dev_item_disable_posthog(inputs)
	if (locale === "es") return es_dev_item_disable_posthog(inputs)
	if (locale === "fr") return fr_dev_item_disable_posthog(inputs)
	if (locale === "pt") return pt_dev_item_disable_posthog(inputs)
	if (locale === "zh") return zh_dev_item_disable_posthog(inputs)
	if (locale === "tr") return tr_dev_item_disable_posthog(inputs)
	if (locale === "ru") return ru_dev_item_disable_posthog(inputs)
	if (locale === "pl") return pl_dev_item_disable_posthog(inputs)
	return en_dev_item_disable_posthog(inputs)
});